var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 105.5,
    height: 105.5,
    rx: 15.25,
    fill: "#FFF8EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 105.5,
    height: 105.5,
    rx: 15.25,
    stroke: "#FFBF49",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.2719 47.0634C74.702 47.0634 70.2913 47.6017 65.7162 48.4988C69.6334 45.8823 73.2068 43.0863 74.3282 41.965C76.9447 39.3485 76.9447 35.0873 74.3282 32.4708C71.7117 29.8543 67.4505 29.8543 64.834 32.4708C63.6828 33.6221 60.8121 37.3001 58.1508 41.3221C59.1226 36.5675 59.7057 31.8578 59.7057 30.2132C59.7057 26.5052 56.7005 23.5 52.9925 23.5C49.2846 23.5 46.2793 26.5052 46.2793 30.2132C46.2793 31.798 46.8325 36.2835 47.7446 40.8885C45.1281 36.9712 42.3322 33.3978 41.2108 32.2765C38.5943 29.66 34.3332 29.66 31.7167 32.2765C29.1002 34.893 29.1002 39.1541 31.7167 41.7706C32.8829 42.9368 36.6656 45.8823 40.7623 48.5885C36.0227 47.6316 31.3279 47.0485 29.7132 47.0485C26.0052 47.0485 23 50.0537 23 53.7617C23 57.4696 26.0052 60.4748 29.7132 60.4748C31.2831 60.4748 35.7236 59.9366 40.2988 59.0245C36.4712 61.5962 33.0174 64.3024 31.926 65.3938C29.3095 68.0103 29.3095 72.2715 31.926 74.888C34.5425 77.5045 38.8036 77.5045 41.4201 74.888C42.4966 73.8115 45.1131 70.4773 47.6399 66.7395C46.8026 71.1202 46.2943 75.2767 46.2943 76.7868C46.2943 80.4948 49.2995 83.5 53.0075 83.5C56.7154 83.5 59.7207 80.4948 59.7207 76.7868C59.7207 75.2319 59.1824 70.8661 58.3003 66.3358C60.8719 70.1633 63.5781 73.6171 64.6696 74.7086C67.2861 77.3251 71.5472 77.3251 74.1637 74.7086C76.7802 72.0921 76.7802 67.8309 74.1637 65.2144C73.1022 64.1529 69.8577 61.6111 66.1946 59.1143C70.5903 59.9665 74.7767 60.4599 76.2868 60.4599C79.9948 60.4599 83 57.4546 83 53.7467C83 50.0387 79.9798 47.0634 76.2719 47.0634Z",
    fill: "#FFBF49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalContent);
export default __webpack_public_path__ + "static/media/PersonalContent.4835179e7126345bea07e485e263ed8a.svg";
export { ForwardRef as ReactComponent };